import { 
  Component, 
  ComponentRef, 
  Inject, 
  OnDestroy, 
  OnInit, 
  TemplateRef, 
  ViewChild, 
  ViewContainerRef,
  AfterViewInit,
  EmbeddedViewRef,
} from '@angular/core';

import { 
  Router,
  ActivatedRoute, 
  ParamMap 
} from '@angular/router';

import { Location } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {Title} from "@angular/platform-browser";

import { 
  MsalInterceptorConfiguration, 
  MsalService, 
  MSAL_INTERCEPTOR_CONFIG 
} from '@azure/msal-angular';


import { 
  AccountInfo, 
  EndSessionRequest 
} from '@azure/msal-browser';

import { LoadingBarService } from '@ngx-loading-bar/core';

import { isNil, isObject } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexErrorService } from './error/datex-error-service';
import { protectedResources } from './auth-config';

import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';
import { WavelengthUiModule, WavelengthShellService, IMenubarItem, MenuItemModel } from 'wavelength-ui';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { app_shell_ComponentContextService } from './app.shell.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

enum EmbedScriptType {
  Inline,
  External
}

@Component({
  standalone: true,
  imports: [
    SharedModule,
    WavelengthUiModule
  ],
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  providers: [
    {
      provide: WavelengthShellService,
      useExisting: app_ShellService
    }
  ]
})
export class ShellComponent {

  title: string = "Footprint";
  subtitle: string = "";
  logo: string = "assets/img/footprint_2024_icon_white.svg";

  account: AccountInfo;
  home: IMenubarItem;
  items: IMenubarItem[];
  menubar: any;
  toolbarItems: IMenubarItem[];
  toolbar: any;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: app_ShellService,
    private $datasources: app_DatasourceService,
    private $flows: app_FlowService,
    private $reports: app_ReportService,
    private $localization: app_LocalizationService,
    private $operations: app_OperationService,
    private $logger: CleanupLoggerService,
    private $context: app_shell_ComponentContextService,

    private location: Location,
    private authService: MsalService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingBarService: LoadingBarService,
    private titleService:Title,
    private datexErrorService: DatexErrorService,
    @Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfiguration: MsalInterceptorConfiguration
  ) {

    this.home = new MenuItemModel(
      'home',
      'icon-ic_fluent_home_20_regular',
      'Home',
      [],
      () => this.openHome()
    );

    this.items = [
    
      new MenuItemModel('inbound', 'icon-datex-Inbound', 'Inbound', [
          new MenuItemModel('inbound_orders', 'icon-datex-InboundOrder', 'Inbound Orders', [],  () => {
              this.$shell.FootprintManager.openinbound_orders_hub(
              false)}
        ),
          new MenuItemModel('returns_hub', 'icon-datex-Returns', 'Returns', [],  () => {
              this.$shell.FootprintManager.openreturns_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('outbound', 'icon-datex-Outbound', 'Outbound', [
          new MenuItemModel('outbound_orders', 'icon-datex-OutboundOrder', 'Outbound Orders', [],  () => {
              this.$shell.FootprintManager.openoutbound_orders_hub(
              false)}
        ),
          new MenuItemModel('warehouse_transfers', 'ms-Icon ms-Icon--DependencyAdd', 'Warehouse Transfers', [],  () => {
              this.$shell.FootprintManager.openwarehouse_transfers_hub(
              false)}
        ),
          new MenuItemModel('pack_verification', 'icon-ic_fluent_barcode_scanner_20_regular', 'Pack Verification', [],  () => {
              this.$shell.FootprintManager.openpack_verification_hub(
              false)}
        ),
          new MenuItemModel('waves', 'icon-datex-Wave', 'Waves', [],  () => {
              this.$shell.FootprintManager.openwaves_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('transportation', 'icon-datex-Carrier', 'Transportation', [
          new MenuItemModel('dock_appointments', 'icon-ic_fluent_calendar_empty_20_regular', 'Dock Appointments', [],  () => {
              this.$shell.FootprintManager.opendock_appointments_hub(
              false)}
        ),
          new MenuItemModel('dock_doors', 'icon-ic_fluent_door_20_regular', 'Dock Doors', [],  () => {
              this.$shell.FootprintManager.opendock_doors_hub(
              {
                warehouseIds:  null 
              },
              false)}
        ),
          new MenuItemModel('driver_check_out', 'icon-ic_fluent_signature_20_regular', 'Driver Check Out', [],  () => {
              this.$shell.FootprintManager.opendriver_check_out_hub(
              {
                orderId:  null ,
                load_container_id:  null 
              },
              false)}
        ),
          new MenuItemModel('load_containers', 'icon-datex-LoadContainer', 'Load Containers', [],  () => {
              this.$shell.FootprintManager.openload_containers_hub(
              false)}
        ),
          new MenuItemModel('shipping_containers', 'icon-ic_fluent_layout_column_two_split_left_20_regular', 'Shipping Containers', [],  () => {
              this.$shell.FootprintManager.openshipping_containers_hub(
              false)}
        ),
          new MenuItemModel('transload_orders', 'icon-datex-OutboundOrder', 'Transload orders', [],  () => {
              this.$shell.FootprintManager.opentransload_orders_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('planning', 'icon-datex-Flow', 'Planning', [
          new MenuItemModel('labor_management_hub', 'icon-ic_fluent_people_team_toolbox_20_regular', 'Labor Management', [],  () => {
              this.$shell.FootprintManager.openlabor_management_hub(
              false)}
        ),
          new MenuItemModel('inspections', 'icon-ic_fluent_box_multiple_search_20_regular', 'Inspections', [],  () => {
              this.$shell.FootprintManager.openinspections_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('inventory', 'icon-datex-Inventory', 'Inventory', [
          new MenuItemModel('inventory', 'icon-datex-Inventory', 'Inventory', [],  () => {
              this.$shell.FootprintManager.openinventory_hub(
              {
                ownerId:  null ,
                projectId:  null ,
                warehouseId:  null 
              },
              false)}
        ),
          new MenuItemModel('activity_hub', 'icon-ic_fluent_tasks_app_20_regular', 'Activity', [],  () => {
              this.$shell.FootprintManager.openactivity_hub(
              false)}
        ),
          new MenuItemModel('lots', 'icon-datex-Lot', 'Lots', [],  () => {
              this.$shell.FootprintManager.openlots_hub(
              false)}
        ),
          new MenuItemModel('serialnumbers', 'icon-datex-SerialNumber', 'Serial Numbers', [],  () => {
              this.$shell.FootprintManager.openserialnumbers_hub(
              false)}
        ),
          new MenuItemModel('inventory_transfers_hub', 'icon-ic_fluent_box_multiple_arrow_right_20_regular', 'Inventory Transfers', [],  () => {
              this.$shell.FootprintManager.openinventory_transfers_hub(
              false)}
        ),
          new MenuItemModel('inventory_count', 'icon-datex-Count', 'Inventory Counts', [],  () => {
              this.$shell.FootprintManager.openinventory_counts_hub(
              false)}
        ),
          new MenuItemModel('replenishment', 'icon-datex-Replenishment', 'Replenishments', [],  () => {
              this.$shell.FootprintManager.openreplenishment_hub(
              false)}
        ),
          new MenuItemModel('warehouses', 'icon-datex-Warehouse', 'Warehouses', [],  () => {
              this.$shell.FootprintManager.openwarehouses_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('owners', 'icon-datex-Owner', 'Owners', [
          new MenuItemModel('owners', 'icon-ic_fluent_video_person_20_filled', 'Owners', [],  () => {
              this.$shell.FootprintManager.openowners_hub(
              false)}
        ),
          new MenuItemModel('projects', 'icon-ic_fluent_person_edit_20_regular', 'Projects', [],  () => {
              this.$shell.FootprintManager.openprojects_hub(
              false)}
        ),
          new MenuItemModel('materials', 'icon-datex-Material', 'Materials', [],  () => {
              this.$shell.FootprintManager.openmaterials_hub(
              {
                ownerId:  null ,
                projectId:  null 
              },
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('billing', 'icon-datex-Billing', 'Billing', [
          new MenuItemModel('billing_contracts', 'ms-Icon ms-Icon--PenWorkspace', 'Billing Contracts', [],  () => {
              this.$shell.FootprintManager.openbilling_contracts_hub(
              false)}
        ),
          new MenuItemModel('billing_records', 'icon-ic_fluent_grid_dots_20_regular', 'Billing Records', [],  () => {
              this.$shell.FootprintManager.openbilling_records_hub(
              false)}
        ),
          new MenuItemModel('invoices', 'icon-ic_fluent_receipt_20_regular', 'Invoices', [],  () => {
              this.$shell.FootprintManager.openinvoices_hub(
              {
                ownerId:  null ,
                projectId:  null 
              },
              false)}
        ),
          new MenuItemModel('work_orders', 'icon-ic_fluent_clipboard_edit_20_regular', 'Work Orders', [],  () => {
              this.$shell.FootprintManager.openwork_orders_hub(
              false)}
        ),
          new MenuItemModel('auto_invoicing_rules_hub', 'ms-Icon ms-Icon--Money', 'Auto-invoicing', [],  () => {
              this.$shell.Invoices.openinvoicing_rules_hub(
              {
                projectId:  null ,
                billingContractId:  null 
              },
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('integrations', 'icon-ic_fluent_cloud_swap_20_regular', 'Integrations', [
          new MenuItemModel('entity_import', 'icon-ic_fluent_cloud_arrow_up_20_regular', 'Entity Import', [],  () => {
              this.$shell.FootprintManager.openentity_import_hub(
              false)}
        ),
          new MenuItemModel('logs', 'icon-ic_fluent_cloud_flow_20_regular', 'Logs & configuration', [],  () => {
              this.$shell.Utilities.openutilities_hub(
              {
                application_name:  null ,
                column_names:  null ,
                filter_values:  null ,
                user_name:  null 
              },
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    
      new MenuItemModel('settings', 'icon-ic_fluent_settings_20_regular', 'Settings', [
          new MenuItemModel('Inventory_configurations', 'ms-Icon ms-Icon--ProductCatalog', 'Inventory configurations', [],  () => {
              this.$shell.FootprintManager.openconfigurations_inventory_hub(
              false)}
        ),
          new MenuItemModel('storage_categories', 'ms-Icon ms-Icon--HomeGroup', 'Storage categories', [],  () => {
              this.$shell.FootprintManager.openconfigurations_storage_categories_hub(
              false)}
        ),
          new MenuItemModel('email_rules', 'icon-ic_fluent_mail_alert_20_regular', 'Email rules', [],  () => {
              this.$shell.Notifications.openauto_email_rules_hub(
              {
                projectId:  null 
              },
              false)}
        ),
          new MenuItemModel('surveys', 'icon-ic_fluent_clipboard_bullet_list_20_regular', 'Surveys', [],  () => {
              this.$shell.FootprintManager.opensurveys_hub(
              false)}
        ),
        ]
        ,      
        () => {},
      ),
    ];

    this.menubar = { 
        inbound: this.items.find(i => i.id == 'inbound') as { hidden: boolean, menubar: {  inbound_orders: { hidden: boolean },  returns_hub: { hidden: boolean },  } }, 
        outbound: this.items.find(i => i.id == 'outbound') as { hidden: boolean, menubar: {  outbound_orders: { hidden: boolean },  warehouse_transfers: { hidden: boolean },  pack_verification: { hidden: boolean },  waves: { hidden: boolean },  } }, 
        transportation: this.items.find(i => i.id == 'transportation') as { hidden: boolean, menubar: {  dock_appointments: { hidden: boolean },  dock_doors: { hidden: boolean },  driver_check_out: { hidden: boolean },  load_containers: { hidden: boolean },  shipping_containers: { hidden: boolean },  transload_orders: { hidden: boolean },  } }, 
        planning: this.items.find(i => i.id == 'planning') as { hidden: boolean, menubar: {  labor_management_hub: { hidden: boolean },  inspections: { hidden: boolean },  } }, 
        inventory: this.items.find(i => i.id == 'inventory') as { hidden: boolean, menubar: {  inventory: { hidden: boolean },  activity_hub: { hidden: boolean },  lots: { hidden: boolean },  serialnumbers: { hidden: boolean },  inventory_transfers_hub: { hidden: boolean },  inventory_count: { hidden: boolean },  replenishment: { hidden: boolean },  warehouses: { hidden: boolean },  } }, 
        owners: this.items.find(i => i.id == 'owners') as { hidden: boolean, menubar: {  owners: { hidden: boolean },  projects: { hidden: boolean },  materials: { hidden: boolean },  } }, 
        billing: this.items.find(i => i.id == 'billing') as { hidden: boolean, menubar: {  billing_contracts: { hidden: boolean },  billing_records: { hidden: boolean },  invoices: { hidden: boolean },  work_orders: { hidden: boolean },  auto_invoicing_rules_hub: { hidden: boolean },  } }, 
        integrations: this.items.find(i => i.id == 'integrations') as { hidden: boolean, menubar: {  entity_import: { hidden: boolean },  logs: { hidden: boolean },  } }, 
        settings: this.items.find(i => i.id == 'settings') as { hidden: boolean, menubar: {  Inventory_configurations: { hidden: boolean },  storage_categories: { hidden: boolean },  email_rules: { hidden: boolean },  surveys: { hidden: boolean },  } }, 
    };

    this.toolbarItems = [

    new MenuItemModel(
      'support',
      'icon-ic_fluent_person_support_20_regular',
      'Support',
      /* Submenu items if present */
      []
      ,
      async () => {
        await this.on_support();
      }
    ),


    new MenuItemModel(
      'help',
      'icon-ic_fluent_question_circle_20_regular',
      'Help',
      /* Submenu items if present */
      []
      ,
      async () => {
        await this.on_help();
      }
    ),

    ];


    this.toolbar = { 
        support: this.toolbarItems.find(i => i.id == 'support') as { hidden: boolean }, 
        help: this.toolbarItems.find(i => i.id == 'help') as { hidden: boolean }, 
    };
  }

  private addScript(type: EmbedScriptType, data: string) {
    switch(type){
      case EmbedScriptType.Inline:
        this.addInlineScript(data);
        break;
      case EmbedScriptType.External:
        this.addExternalScript(data);
        break;
      default:
        throw new Error(`Unknown script type ${type}`);
    }
  }

  private addInlineScript(body: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = body;
    document.body.appendChild(script);
  }

  private addExternalScript(url: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.defer = true;
    document.body.appendChild(script);
  }

  private openHome() {    
    this.$shell.FootprintManager.openorders_hub(
      false
    );
  }

  onLogoutClicked(): void {
    this.authService.logout();
  }

  onInitialized() {
    Promise.resolve().then(() => {
      this.on_init();
    });

    this.account = this.authService.instance.getActiveAccount();
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $workspace: ShellComponent,
  
    $shell: app_ShellService,
    $datasources: app_DatasourceService,
    $flows: app_FlowService,
    $reports: app_ReportService,
    $settings: SettingsValuesService,
    $operations: app_OperationService,
    $utils: UtilsService,
    $context: app_shell_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: app_LocalizationService,
    $event: any
  ) {
  
  // Set title with environment name
  $workspace.title = $context.app.name + ' ' + $context.env.name
  
  // Hide navigation items
  const nav_map: { operation: typeof $operations.FootprintManager.Disable_Accessorials_ChargeEntry, menu_item: any }[] = [
      // Inbound
      { operation: $operations.FootprintManager.Disable_Navigation_Inbound, menu_item: $workspace.menubar.inbound },
      { operation: $operations.FootprintManager.Disable_Navigation_Inbound, menu_item: $workspace.menubar.inbound },
      { operation: $operations.FootprintManager.Disable_Navigation_Inbound, menu_item: $workspace.menubar.inbound },
      // Outbound
      { operation: $operations.FootprintManager.Disable_Navigation_Outbound, menu_item: $workspace.menubar.outbound },
      { operation: $operations.FootprintManager.Disable_Navigation_Outbound_Orders_Hub, menu_item: $workspace.menubar.outbound.menubar.outbound_orders },
      { operation: $operations.FootprintManager.Disable_Navigation_Outbound_Pack_Verification, menu_item: $workspace.menubar.outbound.menubar.pack_verification },
      { operation: $operations.FootprintManager.Disable_Navigation_Outbound_Waves, menu_item: $workspace.menubar.outbound.menubar.waves },
      { operation: $operations.FootprintManager.Disable_Navigation_Outbound_Outbound_Warehouse_Transfers, menu_item: $workspace.menubar.outbound.menubar.warehouse_transfers },
  
      // Transportation
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation, menu_item: $workspace.menubar.transportation },
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation_Dock_Appointments, menu_item: $workspace.menubar.transportation.menubar.dock_appointments },
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation_Dock_Doors, menu_item: $workspace.menubar.transportation.menubar.dock_doors },
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation_Driver_Check_Out, menu_item: $workspace.menubar.transportation.menubar.driver_check_out },
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation_Load_Containers, menu_item: $workspace.menubar.transportation.menubar.load_containers },
      { operation: $operations.FootprintManager.Disable_Navigation_Transportation_Shipping_Containers, menu_item: $workspace.menubar.transportation.menubar.shipping_containers },
  
      // Planning
      { operation: $operations.FootprintManager.Disable_Navigation_Planning, menu_item: $workspace.menubar.planning },
      { operation: $operations.FootprintManager.Disable_Navigation_Planning_Inspections, menu_item: $workspace.menubar.planning.menubar.inspections },
      { operation: $operations.FootprintManager.Disable_Navigation_Planning_Labor_Management, menu_item: $workspace.menubar.planning.menubar.labor_management_hub },
  
      // Inventory
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory, menu_item: $workspace.menubar.inventory },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Inventory_Hub, menu_item: $workspace.menubar.inventory.menubar.inventory },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Inventory_Count, menu_item: $workspace.menubar.inventory.menubar.inventory_count },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Inventory_Transfers, menu_item: $workspace.menubar.inventory.menubar.inventory_transfers_hub },
    //  { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Manufacturing_Orders, menu_item: $workspace.menubar.inventory.menubar.manufacturing_orders },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Lots, menu_item: $workspace.menubar.inventory.menubar.lots },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Replenishment, menu_item: $workspace.menubar.inventory.menubar.replenishment },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Serial_Numbers, menu_item: $workspace.menubar.inventory.menubar.serialnumbers },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Warehouses, menu_item: $workspace.menubar.inventory.menubar.warehouses },
      { operation: $operations.FootprintManager.Disable_Navigation_Inventory_Activity, menu_item: $workspace.menubar.inventory.menubar.activity_hub },
  
      // Owners
      { operation: $operations.FootprintManager.Disable_Navigation_Owners, menu_item: $workspace.menubar.owners },
      { operation: $operations.FootprintManager.Disable_Navigation_Owners_Owners_Hub, menu_item: $workspace.menubar.owners.menubar.owners },
      { operation: $operations.FootprintManager.Disable_Navigation_Owners_Materials, menu_item: $workspace.menubar.owners.menubar.materials },
      { operation: $operations.FootprintManager.Disable_Navigation_Owners_Projects, menu_item: $workspace.menubar.owners.menubar.projects },
  
      // Billing
      { operation: $operations.FootprintManager.Disable_Navigation_Billing, menu_item: $workspace.menubar.billing },
      { operation: $operations.FootprintManager.Disable_Navigation_Billing_Billing_Contracts, menu_item: $workspace.menubar.billing.menubar.billing_contracts },
      { operation: $operations.FootprintManager.Disable_Navigation_Billing_Billing_Records, menu_item: $workspace.menubar.billing.menubar.billing_records },
      { operation: $operations.FootprintManager.Disable_Navigation_Billing_Invoices, menu_item: $workspace.menubar.billing.menubar.invoices },
      { operation: $operations.FootprintManager.Disable_Navigation_Billing_Work_Orders, menu_item: $workspace.menubar.billing.menubar.work_orders },
      { operation: $operations.FootprintManager.Disable_Navigation_Billing_Auto_Invoicing, menu_item: $workspace.menubar.billing.menubar.auto_invoicing_rules_hub },
  
      // Integrations
      { operation: $operations.FootprintManager.Disable_Navigation_Integrations, menu_item: $workspace.menubar.integrations },
      { operation: $operations.FootprintManager.Disable_Navigation_Integrations_Entity_Import, menu_item: $workspace.menubar.integrations.menubar.entity_import },
      // { operation: $operations.FootprintManager.Disable_Navigation_Integrations_Footprint_Api_Manager, menu_item: $workspace.menubar.integrations.menubar.footprint_api_manager },
  
      // Settings
      { operation: $operations.FootprintManager.Disable_Navigation_Settings, menu_item: $workspace.menubar.settings },
      { operation: $operations.FootprintManager.Disable_Navigation_Settings_Inventory_Configurations, menu_item: $workspace.menubar.settings.menubar.Inventory_configurations },
      { operation: $operations.FootprintManager.Disable_Navigation_Settings_Storage_Categories, menu_item: $workspace.menubar.settings.menubar.storage_categories },
      { operation: $operations.FootprintManager.Disable_Navigation_Settings_Surveys, menu_item: $workspace.menubar.settings.menubar.surveys },
   //   { operation: $operations.FootprintManager.Disable_Navigation_Settings_Allocation_Configuration, menu_item: $workspace.menubar.settings.menubar.allocation_configuration},
   //   { operation: $operations.FootprintManager.Disable_Navigation_Settings_Manufacturing_Configuration, menu_item: $workspace.menubar.settings.menubar.manufacturing_orders_configuration}
  ];
  
  let promises: Promise<boolean>[] = [];
  for (let item of nav_map) {
      item.menu_item.hidden = true;
      promises.push(item.operation.isAssigned());
  }
  
  const operationResults = await Promise.all(promises);
  
  for (let i = 0; i < nav_map.length; i++) {
      let item = nav_map[i];
      let isAssigned = operationResults[i];
  
      item.menu_item.hidden = isAssigned;
  }
  
  //Usersnap Widget
  if (await $operations.FootprintManager.Disable_Navigation_UserSnap.isAuthorized()) {
      $workspace.toolbar.support.hidden = true;
  }
  else {
      $workspace.toolbar.support.hidden = false;
  }
  // Document 360 Help Widget
  if (await $operations.FootprintManager.Disable_Navigation_Document360.isAuthorized()) {
      $workspace.toolbar.help.hidden = true;
  }
  else {
      $workspace.toolbar.help.hidden = false;
  }
  }
  on_help(event = null) {
    return this.on_helpInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_helpInternal(
    $workspace: ShellComponent,
  
    $shell: app_ShellService,
    $datasources: app_DatasourceService,
    $flows: app_FlowService,
    $reports: app_ReportService,
    $settings: SettingsValuesService,
    $operations: app_OperationService,
    $utils: UtilsService,
    $context: app_shell_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: app_LocalizationService,
    $event: any
  ) {
  
  
  
  let doc360Content = (await $flows.Document360.get_document360_widget({})).doc30_scriptContent;
  $workspace.addScript(EmbedScriptType.Inline, doc360Content);
  
  }
  on_support(event = null) {
    return this.on_supportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_supportInternal(
    $workspace: ShellComponent,
  
    $shell: app_ShellService,
    $datasources: app_DatasourceService,
    $flows: app_FlowService,
    $reports: app_ReportService,
    $settings: SettingsValuesService,
    $operations: app_OperationService,
    $utils: UtilsService,
    $context: app_shell_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: app_LocalizationService,
    $event: any
  ) {
  
  
  let usersnapContent = (await $flows.Usersnap.get_usersnap_widget({})).usersnap_scriptContent;
  $workspace.addScript(EmbedScriptType.Inline, usersnapContent);
  
  
  
  }
  //#endregion private flows
}
